export const PRIMARY_GOAL_FULL_POINTS = 20;
export const CREDIT_SCORE_FULL_POINTS = 40;
export const METHODOLOGY_FULL_POINTS = 40;
export const ITEMIZED_CREDIT_SCORE = 'CREDIT_SCORE';
export const ITEMIZED_METHODOLOGY = 'METHODOLOGY';
export const ITEMIZED_PRIMARY_GOAL = 'PRIMARY_GOAL';

export enum MethodologyPoints {
  ZERO_POINTS = 0,
  TWO_POINTS = 2,
  THREE_POINTS = 3,
  FIVE_POINTS = 5,
  EIGHT_POINTS = 8,
  THIRTEEN_POINTS = 13,
  TWENTY_ONE_POINTS = 21,
  TWENTY_SIX_POINTS = 26,
  TWENTY_NINE_POINTS = 29,
  THIRTY_FOUR_POINTS = 34,
  THIRTY_SEVEN_POINTS = 37,
}

export enum RewardType {
  CASH = 'CASH',
}

export enum Methodology {
  BigPurchase = 'BIG_PURCHASE',
  BigPurchaseVariant = 'BIG_PURCHASE_VARIANT',
  BuildCredit = 'BUILD_CREDIT',
  CashBack = 'CASH_BACK',
  Debt = 'DEBT',
  DebtVariant = 'DEBT_VARIANT',
  Student = 'STUDENT',
  StudentVariant = 'STUDENT_VARIANT',
  Travel = 'TRAVEL',
}

export const OFFER_FIELDS = [
  'offer.id',
  'offer.name',
  'offer.status',
  'offer.details.annual_fee_details',
  'offer.details.apr_intro_message_list',
  'offer.details.balance_transfer_fee',
  'offer.details.balance_transfer_fee_description',
  'offer.details.balance_transfer_intro_apr',
  'offer.details.balance_transfer_intro_time',
  'offer.details.cons_bullets',
  'offer.details.compare_categories',
  'offer.details.image_alt_text',
  'offer.details.image_source',
  'offer.details.image_source_large',
  'offer.details.image_source_medium',
  'offer.details.is_monetizing',
  'offer.details.legacy_id',
  'offer.details.marketing_bullets_without_terms_and_fees_link',
  'offer.details.max_fico',
  'offer.details.min_fico',
  'offer.details.ongoing_apr',
  'offer.details.pros_bullets',
  'offer.details.rating_stars',
  'offer.details.review_link',
  'offer.details.reward_rate',
  'offer.details.reward_rate_details',
  'offer.details.reward_rate_notes',
  'offer.details.reward_type',
  'offer.details.sign_up_bonus',
  'offer.details.sign_up_bonus_details',
  'offer.details.sign_up_bonus_details_annotation',
  'offer.details.sign_up_bonus_type',
  'offer.details.slug',
  'offer.details.terms_and_fees_link',
  'offer.details.perks',
  'offer.details.promos',
  'offer.details.annual_fee',
  'offer.details.annual_fee_first_year',
  'offer.details.balance_transfer_fee',
  'offer.details.balance_transfer_intro_time',
  'offer.details.cobrand_airline',
  'offer.details.cobrand_hotel',
  'offer.details.foreign_transaction_fee',
  'offer.details.is_monetizing',
  'offer.details.minimum_deposit',
  'offer.details.purchase_intro_time',
  'offer.details.rating_stars',
  'offer.details.reward_type',
  'offer.details.rewards',
  'offer.derived_details.apply_link',
  'offer.derived_details.approval_likelihood',
  'offer.derived_details.monetizable',
  'offer.derived_details.terms_and_fees_redirect_link',
  'offer.product.id',
  'offer.product.name',
  'offer.product.institution.id',
  'offer.product.institution.name',
  'offer.details.limited_credit_history',
  'offer.details.rewards_rates',
];

export const EXCLUDED_OFFER_IDS = [
  '38dc0680-45e8-11ee-aaaa-671125a51296',
  '75079de6-f143-11eb-bb2d-3b5b3c65298c',
  '95a6568f-87e4-488c-a654-bc21681cb924',
  'ba267a88-d25a-11ed-aa13-573e3d0fc9a5',
  'bd632d7e-d258-11ed-b274-3f4ece2ac07e',
  '18dbd51f-0fd4-4d42-b043-ed500872a771',
  '1ef7b7ff-251a-4c94-b941-186b378d81fd',
  '825c00a4-4e7e-460c-bbed-7b63d643b54c',
  'f0a53916-456a-11eb-90c7-2b040cd9cd80',
];
export const EXCLUDED_OFFER_ID_SET = new Set(EXCLUDED_OFFER_IDS);
